import { t } from '../i18n'
import { isApiError } from '../api/errors'

/**
 * Maps a failed `POST /sources/{id}/retrievals` call to a user-facing
 * message. The backend error for this endpoint can carry infrastructure
 * detail meant for logs, not end users — e.g. HttpRetrievalTriggerService
 * embeds the ingestion service's URI and raw HTTP status text into the
 * exception message it forwards as `ApiError.message`. Branch on
 * `status`/`code` instead of surfacing `message` directly; the raw error is
 * still logged in full by `normalizeError` (see api/errors.ts) for
 * debugging.
 */
export function retrievalTriggerErrorMessage(err: unknown): string {
  if (!isApiError(err)) return t('errors.retrievalTrigger.generic')

  switch (err.status) {
    case 404:
      return t('errors.retrievalTrigger.notFound')
    case 409:
      return t('errors.retrievalTrigger.disabled')
    case 502:
    case 503:
      return t('errors.retrievalTrigger.unavailable')
    case 0:
      return t('errors.retrievalTrigger.offline')
    default:
      return t('errors.retrievalTrigger.generic')
  }
}
